<template>
  <v-menu
    :close-on-content-click="false"
    v-model="menuOpened"
    :nudge-width="450"
    max-width="600"
    transition="scale-transition"
  >
    <template v-slot:activator="{ on }">
      <v-tooltip top>
        <template v-slot:activator="{ on: onTooltip }">
          <v-btn icon
                 class="mr-2"
                 :color="iconColor"
                 v-on="{ ...onTooltip, ...on }"
                 @click.stop.prevent=""
          >
            <v-icon>mdi-filter-outline</v-icon>
          </v-btn>
        </template>
        <span>Filtrar por</span>
      </v-tooltip>
    </template>
    <v-card>
      <v-card-text class="text--primary">
        <v-row dense class="mt-1">
          <v-col cols="12" sm="6">
            <px-date-picker dense
                            input-class="rounded-tag-small"
                            label="Data entrada inicial"
                            v-model="localDataInicial"/>
          </v-col>
          <v-col cols="12" sm="6">
            <px-date-picker dense
                            input-class="rounded-tag-small"
                            label="Data entrada final"
                            v-model="localDataFinal"/>
          </v-col>
        </v-row>
        <v-row dense class="mt-1">
          <v-col cols="12" sm="6">
            <px-date-picker dense
                            input-class="rounded-tag-small"
                            label="Previsão entrega inicial"
                            v-model="localDataEntregaInicial"/>
          </v-col>
          <v-col cols="12" sm="6">
            <px-date-picker dense
                            input-class="rounded-tag-small"
                            label="Previsão entrega final"
                            v-model="localDataEntregaFinal"/>
          </v-col>
        </v-row>
        <v-row dense class="mt-1">
          <v-col cols="12">
            <px-autocomplete-comprador
              required
              dense
              class="rounded-tag-small"
              v-model="localEmpresa"/>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12">
            <px-autocomplete-locais-entrega
              dense
              class="rounded-tag-small"
              v-model="localLocalEntrega"/>
          </v-col>
        </v-row>
        <v-row dense class="mt-1">
          <v-col cols="12">
            <px-autocomplete-user-comprador-multiple
              outlined
              dense
              label="Solicitantes responsáveis"
              autocomplete="off"
              class="rounded-tag-small"
              :roles="['ROLE_REQUISICAO']"
              v-model="localResponsavel"/>
          </v-col>
        </v-row>
        <v-row dense class="mt-1">
          <v-col cols="12">
            <px-autocomplete-user-comprador-multiple
              outlined
              dense
              label="Compradores responsáveis"
              autocomplete="off"
              class="rounded-tag-small"
              :roles="['ROLE_COMPRADOR']"
              v-model="localCompradorResponsavel"/>
          </v-col>
        </v-row>
        <v-row dense class="mt-1">
          <v-col cols="12">
            <px-autocomplete-produto-multiple v-model="localProduto"
                                     class="rounded-tag-small"
                                     show-details
                                     dense
                                     base-path="/produtos/page"/>
          </v-col>
        </v-row>
        <v-row dense class="mt-1">
          <v-col cols="12">
            <px-autocomplete-centro-custo-multiple
              class="rounded-tag-small"
              dense
              v-model="localCentroCusto"/>
          </v-col>
        </v-row>
        <v-row dense class="mt-1">
          <v-col cols="12">
            <px-autocomplete-projeto-multiple
              dense
              class="rounded-tag-small"
              v-model="localProjeto"/>
          </v-col>
        </v-row>
        <v-row dense class="mt-1">
          <v-col cols="12">
            <px-autocomplete-grupo-multiple
              dense
              class="rounded-tag-small"
              v-model="localGrupo"/>
          </v-col>
        </v-row>
        <v-row dense class="mt-1">
          <v-col cols="12">
            <px-select-enum
              dense
              multiple
              chips
              small-chips
              label="Urgência"
              deletable-chips
              :items="urgencias"
              class="rounded-tag-small"
              v-model="localUrgencia"/>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="pa-3">
        <v-spacer/>
        <v-btn text class="normal-btn-text" @click="clearFilters">
          Limpar filtros
        </v-btn>
        <v-btn color="primary"
               class="normal-btn-text rounded-tag-small elevation-0"
               @click="emitChange">
          Aplicar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import { UrgenciaRequisicao } from 'px-business-components';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      menuOpened: false,
      localEmpresa: null,
      localLocalEntrega: null,
      localCentroCusto: [],
      localProduto: [],
      localProjeto: [],
      localResponsavel: [],
      localCompradorResponsavel: [],
      localGrupo: [],
      localUrgencia: [],
      localDataInicial: null,
      localDataFinal: null,
      localDataEntregaInicial: null,
      localDataEntregaFinal: null,
      urgencias: UrgenciaRequisicao.values,
    };
  },
  computed: {
    ...mapGetters('requisicaoGeracao', ['hasCustomFilters']),
    iconColor() {
      return this.hasCustomFilters ? 'primary' : '';
    },
    centrosCustos: {
      get() {
        return this.$store.getters['requisicaoGeracao/centrosCustos'];
      },
      set(centrosCustos) {
        this.$store.dispatch('requisicaoGeracao/centrosCustos', centrosCustos);
      },
    },
    solicitantes: {
      get() {
        return this.$store.getters['requisicaoGeracao/solicitantes'];
      },
      set(solicitantes) {
        this.$store.dispatch('requisicaoGeracao/solicitantes', solicitantes);
      },
    },
    empresa: {
      get() {
        return this.$store.getters['requisicaoGeracao/empresa'];
      },
      set(empresa) {
        this.$store.dispatch('requisicaoGeracao/empresa', empresa);
      },
    },
    localEntrega: {
      get() {
        return this.$store.getters['requisicaoGeracao/localEntrega'];
      },
      set(localEntrega) {
        this.$store.dispatch('requisicaoGeracao/localEntrega', localEntrega);
      },
    },
    produto: {
      get() {
        return this.$store.getters['requisicaoGeracao/produto'];
      },
      set(produto) {
        this.$store.dispatch('requisicaoGeracao/produto', produto);
      },
    },
    projeto: {
      get() {
        return this.$store.getters['requisicaoGeracao/projeto'];
      },
      set(projeto) {
        this.$store.dispatch('requisicaoGeracao/projeto', projeto);
      },
    },
    grupo: {
      get() {
        return this.$store.getters['requisicaoGeracao/grupo'];
      },
      set(grupo) {
        this.$store.dispatch('requisicaoGeracao/grupo', grupo);
      },
    },
    dataFinal: {
      get() {
        return this.$store.getters['requisicaoGeracao/dataFinal'];
      },
      set(dataFinal) {
        this.$store.dispatch('requisicaoGeracao/dataFinal', dataFinal);
      },
    },
    dataInicial: {
      get() {
        return this.$store.getters['requisicaoGeracao/dataInicial'];
      },
      set(dataInicial) {
        this.$store.dispatch('requisicaoGeracao/dataInicial', dataInicial);
      },
    },
    dataEntregaInicial: {
      get() {
        return this.$store.getters['requisicaoGeracao/dataEntregaInicial'];
      },
      set(dataEntregaInicial) {
        this.$store.dispatch('requisicaoGeracao/dataEntregaInicial', dataEntregaInicial);
      },
    },
    dataEntregaFinal: {
      get() {
        return this.$store.getters['requisicaoGeracao/dataEntregaFinal'];
      },
      set(dataEntregaFinal) {
        this.$store.dispatch('requisicaoGeracao/dataEntregaFinal', dataEntregaFinal);
      },
    },
    urgencia: {
      get() {
        return this.$store.getters['requisicaoGeracao/urgencia'];
      },
      set(urgencia) {
        this.$store.dispatch('requisicaoGeracao/urgencia', urgencia);
      },
    },
    compradores: {
      get() {
        return this.$store.getters['requisicaoGeracao/compradores'];
      },
      set(compradores) {
        this.$store.dispatch('requisicaoGeracao/compradores', compradores);
      },
    },
  },
  methods: {
    emitChange() {
      this.empresa = this.localEmpresa;
      this.localEntrega = this.localLocalEntrega;
      this.centrosCustos = this.localCentroCusto;
      this.produto = this.localProduto;
      this.projeto = this.localProjeto;
      this.solicitantes = this.localResponsavel;
      this.grupo = this.localGrupo;
      this.dataInicial = this.localDataInicial;
      this.dataFinal = this.localDataFinal;
      this.dataEntregaInicial = this.localDataEntregaInicial;
      this.dataEntregaFinal = this.localDataEntregaFinal;
      this.urgencia = this.localUrgencia;
      this.compradores = this.localCompradorResponsavel;
      this.$emit('change');
      this.close();
    },
    clearFilters() {
      this.localEmpresa = null;
      this.localLocalEntrega = null;
      this.localCentroCusto = [];
      this.localProduto = [];
      this.localProjeto = [];
      this.localResponsavel = [];
      this.localGrupo = [];
      this.localDataInicial = null;
      this.localDataFinal = null;
      this.localDataEntregaInicial = null;
      this.localDataEntregaFinal = null;
      this.localUrgencia = [];
      this.localCompradorResponsavel = [];
      this.emitChange();
    },
    close() {
      this.menuOpened = false;
    },
  },
  created() {
    this.localEmpresa = this.empresa || null;
    this.localLocalEntrega = this.localEntrega || null;
    this.localCentroCusto = this.centrosCustos || [];
    this.localProduto = this.produto || [];
    this.localProjeto = this.projeto || [];
    this.localResponsavel = this.solicitantes || [];
    this.localGrupo = this.grupo || [];
    this.localDataInicial = this.dataInicial || null;
    this.localDataFinal = this.dataFinal || null;
    this.localDataEntregaInicial = this.dataEntregaInicial || null;
    this.localDataEntregaFinal = this.dataEntregaFinal || null;
    this.localUrgencia = this.urgencia || [];
    this.localCompradorResponsavel = this.compradores || [];
  },
};
</script>
